import { CheckoutMedia, resolveCheckoutMedia } from './CheckoutMedia';

export function UpsellMedia({ src }: { src: string }) {
  const media = resolveCheckoutMedia(src);
  return <CheckoutMedia src={src} title="Vídeo da oferta"
    className={media.kind === 'image' ? 'vp-upsell-media' : 'vp-upsell-media vp-upsell-video'} />;
}
